import React from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

// ترقيم مختصر: "1-80 / 49135" + زرار سابق/تالي — الأسهم بتنعكس في العربي.
const ReportsPager = ({ page, pageSize, total, onPageChange, isAr, disabled = false }) => {
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, total);
    const canPrev = !disabled && page > 1;
    const canNext = !disabled && page < totalPages;
    const PrevIcon = isAr ? MdChevronRight : MdChevronLeft;
    const NextIcon = isAr ? MdChevronLeft : MdChevronRight;
    const buttonClass = (enabled) =>
        `flex items-center justify-center w-10 h-9 text-slate-700 transition-colors ${enabled ? 'hover:bg-slate-200 cursor-pointer' : 'opacity-40 cursor-not-allowed'}`;

    return (
        <div className="flex items-center gap-3">
            <span className="text-sm text-slate-700 tabular-nums whitespace-nowrap" dir="ltr">
                {start}-{end} / {total}
            </span>
            <div className="flex items-stretch rounded-lg bg-slate-100 border border-slate-200 overflow-hidden divide-x divide-slate-200 rtl:divide-x-reverse">
                <button type="button" className={buttonClass(canPrev)} disabled={!canPrev} onClick={() => onPageChange(page - 1)} aria-label={isAr ? 'السابق' : 'Previous'}>
                    <PrevIcon size={22} />
                </button>
                <button type="button" className={buttonClass(canNext)} disabled={!canNext} onClick={() => onPageChange(page + 1)} aria-label={isAr ? 'التالي' : 'Next'}>
                    <NextIcon size={22} />
                </button>
            </div>
        </div>
    );
};

export default ReportsPager;
